import { Grid, csx } from '@vtex/admin-ui'
import React from 'react'

import type { ShippingData } from '../../../../../../core/requests/checkout'
import type { Package } from '../../../../../../core/typings'
import { DeliveryPackage } from './DeliveryPackageAddress'
import { PickupPackageAddress } from './PickupPackageAddress'
import { TakeAwayPackageAddress } from './TakeAwayPackageAddress'

export type PackageAddressProps = {
  productPackage: Package
  addressForDelivery: ShippingData | undefined
}

export const PackageAddress = ({
  productPackage,
  addressForDelivery,
}: PackageAddressProps) => {
  return (
    <div
      className={csx({
        justifyContent: 'space-between',
        alignItems: 'center',
        display: 'flex',
      })}
    >
      <Grid rowGap="1rem">
        {productPackage.deliveryChannel === 'delivery' ? (
          <DeliveryPackage deliveryAddress={addressForDelivery?.address} />
        ) : productPackage.selectedSlaType === 'take-away' ? (
          <TakeAwayPackageAddress
            pickupStoreInfo={productPackage.selectedSlaObj?.pickupStoreInfo}
          />
        ) : (
          <PickupPackageAddress
            pickupStoreInfo={productPackage.selectedSlaObj?.pickupStoreInfo}
          />
        )}
      </Grid>
    </div>
  )
}
